import { useState, useEffect } from 'react';
import CookieSettings from './CookieSettings';
import './CookieConsent.css';

function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('payible_cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    const consentData = {
      accepted: true,
      timestamp: new Date().toISOString(),
      preferences: {
        essential: true,
        analytics: true,
        preferences: true
      }
    };
    localStorage.setItem('payible_cookie_consent', JSON.stringify(consentData));
    setVisible(false);
    setSettingsOpen(false);

    // Trigger cookie application
    applyCookiePreferences(consentData.preferences);
  };

  const handleReject = () => {
    const consentData = {
      accepted: false,
      timestamp: new Date().toISOString(),
      preferences: {
        essential: true, // Essential cookies always true
        analytics: false,
        preferences: false
      }
    };
    localStorage.setItem('payible_cookie_consent', JSON.stringify(consentData));
    setVisible(false);
    setSettingsOpen(false);

    // Apply only essential cookies
    applyCookiePreferences(consentData.preferences);
  };

  const handleConfirmChoices = (choices) => {
    const consentData = {
      accepted: true,
      custom: true,
      timestamp: new Date().toISOString(),
      preferences: {
        essential: true, // Essential cookies always enabled
        analytics: choices.analytics || false,
        preferences: true
      }
    };
    localStorage.setItem('payible_cookie_consent', JSON.stringify(consentData));
    setVisible(false);
    setSettingsOpen(false);

    // Apply only the selected cookie preferences
    applyCookiePreferences(consentData.preferences);
  };

  const applyCookiePreferences = (preferences) => {
    // Example implementation - you can expand this based on your needs

    // Essential cookies (always applied)
    document.cookie = "essential_cookies_enabled=true; path=/; max-age=31536000";

    // Analytics cookies
    if (preferences.analytics) {
      document.cookie = "analytics_enabled=true; path=/; max-age=31536000";
      // Initialize analytics here if needed
      console.log("Analytics cookies enabled");
      // Example: initializeGoogleAnalytics();
    } else {
      document.cookie = "analytics_enabled=false; path=/; max-age=31536000";
      // Disable analytics tracking
      console.log("Analytics cookies disabled");
    }

    // Preference cookies
    if (preferences.preferences) {
      document.cookie = "preferences_enabled=true; path=/; max-age=31536000";
      // Apply user preference tracking here
      console.log("Preference cookies enabled");
      // Example: loadUserPreferences();
    } else {
      document.cookie = "preferences_enabled=false; path=/; max-age=31536000";
      console.log("Preference cookies disabled");
    }

    // Dispatch event for other components to react to cookie changes
    window.dispatchEvent(new CustomEvent('cookiePreferencesChanged', { detail: preferences }));
  };

  // Function to get current cookie preferences (useful for other components)
  const getCurrentPreferences = () => {
    const consent = localStorage.getItem('payible_cookie_consent');
    if (consent) {
      try {
        const parsed = JSON.parse(consent);
        return parsed.preferences || { essential: true, analytics: false, preferences: false };
      } catch (e) {
        return { essential: true, analytics: false, preferences: false };
      }
    }
    return { essential: true, analytics: false, preferences: false };
  };

  if (!visible) return null;

  return (
    <>
      <div className="cc-banner">
        <h3 className="cc-heading" style={{
          color: '#fff',
          fontFamily: 'var(--font-primary)',
          fontWeight: 700,
          margin: '0 0 12px 0',
        }}>
          We value your privacy
        </h3>
        <p className="cc-body" style={{
          color: 'rgba(255,255,255,0.7)',
          fontFamily: 'var(--font-primary)',
          lineHeight: 1.6,
          margin: '0 0 20px 0',
        }}>
          Payible uses cookies to secure your account infrastructure and process transactions.
          With your permission, we also use performance tracking to optimize chart latency and
          analyze platform traffic.{' '}
          <button
            onClick={() => setSettingsOpen(true)}
            className="cc-body"
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
              fontFamily: 'var(--font-primary)',
            }}
          >
            Learn more and manage
          </button>
        </p>
        <button
          onClick={handleAccept}
          className="cc-btn"
          style={{
            width: '100%',
            padding: '11px 0',
            backgroundColor: 'var(--color-primary)',
            color: 'var(--color-bg)',
            border: 'none',
            borderRadius: '8px',
            fontFamily: 'var(--font-primary)',
            fontWeight: 700,
            cursor: 'pointer',
            marginBottom: '10px',
          }}
        >
          Accept All
        </button>
        <button
          onClick={handleReject}
          className="cc-btn"
          style={{
            width: '100%',
            padding: '11px 0',
            backgroundColor: 'transparent',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: '8px',
            fontFamily: 'var(--font-primary)',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Reject non-essential cookies
        </button>
      </div>

      {settingsOpen && (
        <CookieSettings
          onClose={() => setSettingsOpen(false)}
          onAcceptAll={handleAccept}
          onConfirm={handleConfirmChoices}
        />
      )}
    </>
  );
}

export default CookieConsent;